import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "geovinum_consent_v1";

export function getConsent() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch { return null; }
}

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState({ functional: true, analytics: false, marketing: false });
  const [details, setDetails] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (!c) setOpen(true);
  }, []);

  const save = (which) => {
    const next = which === "all"
      ? { functional: true, analytics: true, marketing: true }
      : which === "essential"
      ? { functional: true, analytics: false, marketing: false }
      : prefs;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...next, ts: Date.now() }));
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-5 pb-[calc(0.75rem_+_var(--safe-bottom))] pointer-events-none" data-testid="cookie-banner">
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-2xl border border-[#1F3A5F]/15 bg-white shadow-2xl p-5 md:p-6">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-[#E5276A] shrink-0 mt-0.5" />
          <div className="flex-1 text-sm text-[#1F3A5F]">
            <b>Cookies & vie privée.</b> Nous utilisons des cookies pour faire fonctionner geoVINUM. Vous pouvez accepter tout, refuser le non-essentiel, ou personnaliser.
            <Link to="/legal/privacy" className="ml-1 underline text-[#E5276A]">En savoir plus</Link>.
          </div>
        </div>
        {details && (
          <div className="mt-4 space-y-2 border-t border-[#1F3A5F]/10 pt-3" data-testid="cookie-details">
            <label className="flex items-center gap-2 text-xs text-[#4A5568]"><input type="checkbox" checked disabled className="accent-[#E5276A]" /> <b>Fonctionnels</b> (session, panier, langue — requis)</label>
            <label className="flex items-center gap-2 text-xs text-[#4A5568]"><input type="checkbox" checked={prefs.analytics} onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })} className="accent-[#E5276A]" data-testid="cookie-analytics" /> <b>Analytics</b> (mesure d'usage anonyme)</label>
            <label className="flex items-center gap-2 text-xs text-[#4A5568]"><input type="checkbox" checked={prefs.marketing} onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} className="accent-[#E5276A]" data-testid="cookie-marketing" /> <b>Marketing</b> (offres ciblées)</label>
          </div>
        )}
        <div className="mt-4 flex flex-wrap gap-2 justify-end">
          <button data-testid="cookie-customize" onClick={() => setDetails((v) => !v)} className="text-xs text-[#8B95A1] hover:text-[#1F3A5F] font-bold px-3 py-1.5">{details ? "Masquer" : "Personnaliser"}</button>
          <button data-testid="cookie-essential" onClick={() => save("essential")} className="text-xs text-[#1F3A5F] hover:text-[#E5276A] font-bold px-4 py-2 rounded-lg border border-[#1F3A5F]/15">Essentiels uniquement</button>
          {details && (
            <button data-testid="cookie-save-prefs" onClick={() => save("custom")} className="text-xs text-[#1F3A5F] font-bold px-4 py-2 rounded-lg border border-[#1F3A5F]/15 bg-[#FBF7F3]">Enregistrer mes choix</button>
          )}
          <button data-testid="cookie-accept-all" onClick={() => save("all")} className="text-xs text-white font-bold px-4 py-2 rounded-lg bg-[#E5276A] hover:bg-[#C01661]">Tout accepter</button>
        </div>
      </div>
    </div>
  );
}
